/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Component imports.
 */
import { StoriesComponent } from './stories.component';
import { StoryProgressComponent } from './components/story-progress/story-progress.component';
import { StoryProgressBarComponent } from './components/story-progress-bar/story-progress-bar.component';
import { StoryMainComponent } from './components/story-main/story-main.component';
import { StoryCreationComponent } from './components/story-creation/story-creation.component';
import { ThumbnailViewsComponent } from '../share/components/thumbnail-views/thumbnail-views.component';

// TODO: Rahul: need to handle all static strings from constant and fetch colours from colour pallete

/**
 * Module imports.
 */
import { ReactiveFormsModule } from '@angular/forms';
// import { CommonsModule } from '../common/commons.module';
import { ShareModule } from '../share/share.module';
import { StoryTutorialComponent } from './components/story-tutorial/story-tutorial/story-tutorial.component';
@NgModule({
  declarations: [
    StoriesComponent,
    StoryCreationComponent,
    StoryMainComponent,
    StoryProgressComponent,
    StoryProgressBarComponent,
    StoryTutorialComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ShareModule
  ],
  exports: [
    StoriesComponent,
    StoryCreationComponent,
    StoryTutorialComponent,
    ThumbnailViewsComponent
  ]
})
export class StoriesModule { }
